import React from 'react';
import { StyledProjectLayout } from './index.style';
import ProjectHeader from './ProjectHeader';
import ProjectInput from './ProjectInput';
import ProjectList from './ProjectList';

const Project = () => (
  <StyledProjectLayout>
    <ProjectHeader />
    <ProjectInput />
    <ProjectList />
  </StyledProjectLayout>
);

export default Project;
